import { IInvoice } from '../interfaces';

type VatLine = Pick<IInvoice['lines'][number], 'vat_rate' | 'vat_amount'>;

export type VatRateTotal = {
    rate: VatLine['vat_rate'];
    amount: number;
};

/**
 * VAT summed per rate, for the summary under the lines. Empty when that summary
 * would only repeat what is already on screen: with a single rate it equals the
 * total VAT, and when every rate sits on one line each, the lines already show
 * each rate's amount.
 */
export function vatBreakdown(lines: readonly VatLine[]): VatRateTotal[] {
    const totals = new Map<VatLine['vat_rate'], { amount: number; lineCount: number }>();
    for (const line of lines) {
        const current = totals.get(line.vat_rate) ?? { amount: 0, lineCount: 0 };
        totals.set(line.vat_rate, {
            amount: current.amount + Number(line.vat_amount),
            lineCount: current.lineCount + 1
        });
    }

    const rateSharedByLines = [...totals.values()].some((total) => total.lineCount > 1);
    if (totals.size < 2 || !rateSharedByLines) {
        return [];
    }
    return [...totals].map(([rate, total]) => ({ rate, amount: total.amount }));
}
